import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeerBottelGlass = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.beer-bottle{fill:none;}.beer-bottle{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "beer-bottle",
			d: "M14.694,20.063,14,9.063A1,1,0,0,1,15,8h5.5a1,1,0,0,1,1,1.063l-.694,11a1,1,0,0,1-1,.937H15.692a1,1,0,0,1-1-.937Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "beer-bottle",
			d: "M8.583,4.864l.166-.332a1.059,1.059,0,0,0,0-.947h0A1.061,1.061,0,0,0,7.8,3H5.669a1.059,1.059,0,0,0-.947.585h0a1.059,1.059,0,0,0,0,.947l.166.332a1.2,1.2,0,0,1,.127.537v.985A5.292,5.292,0,0,1,3.93,9.6l-.344.451A5.29,5.29,0,0,0,2.5,13.26v5.623A2.117,2.117,0,0,0,4.618,21H8.853a2.118,2.118,0,0,0,2.118-2.118V13.26a5.292,5.292,0,0,0-1.085-3.211L9.541,9.6A5.294,5.294,0,0,1,8.456,6.386V5.4A1.2,1.2,0,0,1,8.583,4.864Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "beer-bottle",
			d: "M5.01,5.49H8.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "beer-bottle",
			d: "M10.97,17H2.51"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "beer-bottle",
			d: "M10.97,13H2.51"
		})
	]
});
export default SvgBeerBottelGlass;
